import React from 'react';
import InfoPage, { Section } from '../../components/InfoPage';

const Terms = () => (
  <InfoPage title="Terms of service" lastUpdated="March 1, 2026">
    <p>
      By accessing this site or placing an order, you agree to the following terms. Please read them carefully.
    </p>

    <Section heading="Use of the site">
      <p>
        You agree to use the site lawfully and not interfere with security, scrape content at scale, or impersonate another person.
        We may suspend access if these terms are violated.
      </p>
    </Section>

    <Section heading="Orders and payment">
      <p>
        Prices are listed in USD and may change at any time. An order is binding only once we send the confirmation email and the payment is captured.
        We may cancel any order suspected of fraud or pricing error.
      </p>
    </Section>

    <Section heading="Product disclaimers">
      <p>
        K-Root products are cosmetic and intended to support a healthy scalp. They are not medical devices and do not treat, cure, or prevent disease.
        If you have a scalp condition or allergy, consult a dermatologist before use.
      </p>
    </Section>

    <Section heading="Intellectual property">
      <p>
        All content on this site — logos, copy, photos, and code — is the property of K-Root or its licensors. You may not copy or redistribute without written permission.
      </p>
    </Section>

    <Section heading="Limitation of liability">
      <p>
        To the maximum extent permitted by law, K-Root is not liable for indirect or consequential damages arising from product use.
      </p>
    </Section>

    <Section heading="Governing law">
      <p>
        These terms are governed by the laws of the State of Delaware, United States.
      </p>
    </Section>
  </InfoPage>
);

export default Terms;
